import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export interface RecommendStylesAndFontsData {
  ai_suggestion_request_id: number
}

export interface RecommendStylesAndFontsVariables {
  brandKitId: number
}

export type RecommendStylesAndFontsOptions = Omit<
  UseMutationOptions<RecommendStylesAndFontsData, unknown, RecommendStylesAndFontsVariables>,
  'mutationKey' | 'mutationFn'
>

export const recommendStylesAndFonts = async ({
  workspaceId,
  brandKitId,
}: RecommendStylesAndFontsVariables & { workspaceId: number }) => {
  const response = await sendToApi<RecommendStylesAndFontsData>(
    `/w/${workspaceId}/brand_kits/${brandKitId}/recommend_styles_and_fonts`,
    {
      method: 'POST',
    },
  )

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred while generating style recommendations. Please try again.',
    )
  }
  return response.data
}

export const useRecommendStylesAndFonts = (options?: RecommendStylesAndFontsOptions) => {
  const workspaceId = useCurrentWorkspaceId()

  return useMutation<RecommendStylesAndFontsData, unknown, RecommendStylesAndFontsVariables>(
    'recommendStylesAndFonts',
    async (variables) => {
      return recommendStylesAndFonts({ workspaceId, ...variables })
    },
    options,
  )
}
